export default "__VITE_ASSET__Bi6$gEfK__"